"use client";

import { useRouter } from "next/navigation";
import { useState } from "react";
import { Button } from "@tillix/ui-atoms/button";
import { Dialog } from "@tillix/ui-atoms/dialog";
import { useAppointmentT } from "../i18n/use-t";

/**
 * "Your session has timed out" dialog, rendered over the preauth gate when
 * the dashboard is reached via `/appointment?expired=1` (SessionWatcher and
 * NOT_AUTHED action results navigate there). Dismissing it drops the query
 * param so a reload doesn't re-announce the timeout.
 */
export default function SessionExpiredDialog() {
  const t = useAppointmentT();
  const router = useRouter();
  const [open, setOpen] = useState(true);

  const handleOpenChange = (next: boolean) => {
    setOpen(next);
    if (!next) router.replace("/appointment");
  };

  return (
    <Dialog onOpenChange={handleOpenChange} open={open}>
      <Dialog.Portal>
        <Dialog.Backdrop />
        <Dialog.Popup>
          <Dialog.Header>
            <Dialog.Title>{t("gate.sessionExpired.title")}</Dialog.Title>
            <Dialog.Description>
              {t("gate.sessionExpired.description")}
            </Dialog.Description>
          </Dialog.Header>
          <div className="mt-4 flex justify-end">
            <Dialog.Close
              render={(props) => (
                <Button {...props}>{t("gate.sessionExpired.dismiss")}</Button>
              )}
            />
          </div>
        </Dialog.Popup>
      </Dialog.Portal>
    </Dialog>
  );
}
